module.exports = __webpack_public_path__ + "static/media/icon-onboarding.c00e24c2.svg";